import React, { useEffect } from 'react';
import Container from '@material-ui/core/Container';
import { containerStyles } from '../../theme/containerStyles';
import { useTranslation } from 'react-i18next';

interface Props { }

const ContactRoot: React.FC<Props> = () => {
  const containerClasses = containerStyles();
  const { t } = useTranslation(["contact"]);
  const showSuccess = (event) => {
    if (typeof event.data === "string") {
      let zf_ifrm_data = event.data.split("|");
      let zf_perma = zf_ifrm_data[0];
      let zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 15) + "px";
      let iframe = document.getElementById("zf_div_Hy_3ca561sNfd3CidpEJvna1c7VvVZD4Hx0_ZS6MO0w").getElementsByTagName("iframe")[0];
      if ((iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0) {
        let prevIframeHeight = iframe.style.height;
        if (prevIframeHeight != zf_ifrm_ht_nw) {
          iframe.style.height = zf_ifrm_ht_nw;
        }
      }
    }
  }
  useEffect(() => {
    let f = document.createElement("iframe");
    f.src = 'https://forms.zohopublic.com/planwellguide/form/PWGCONTACTUS/formperma/Hy_3ca561sNfd3CidpEJvna1c7VvVZD4Hx0_ZS6MO0w?zf_rszfm=1';
    f.style.border = "none";
    f.style.height = "839px";
    f.style.width = "90%";
    f.style.transition = "all 0.5s ease";// No I18N
    f.style.display = "block";
    f.style.margin = "0 auto";
    let d = document.getElementById("zf_div_Hy_3ca561sNfd3CidpEJvna1c7VvVZD4Hx0_ZS6MO0w");
    if (d.children.length === 0) {
      d.appendChild(f);
    }
    window.addEventListener('message', showSuccess, false);
    return function () {
      window.removeEventListener('message', showSuccess)
    }
  }, [])
  return (
    <div className={containerClasses.root}>
      <Container maxWidth="lg" className={containerClasses.container} style={{ marginTop: 48 }}>
        <div style={{ margin: "0 auto", width: "100%" }} id="zf_div_Hy_3ca561sNfd3CidpEJvna1c7VvVZD4Hx0_ZS6MO0w"></div>
      </Container>
    </div>
  )
}

export default ContactRoot;
